<template>
  <div class="mt-4 container d-flex justify-content-center align-items-center">
    <span class="poweredby-text">Powered By</span>
    <a
      rel="noopener noreferrer"
      href="https://abacus.co"
      alt="The iPad POS System you love"
      title="The iPad POS System you love"
      target="_blank"
    >
      <img alt="logo" class="poweredby-image" :src="logoUrl" />
    </a>
  </div>
</template>
<script>
import { wcconfig } from "../../../wcConfig";
export default {
  data() {
    return {
      logoUrl: ""
    };
  },
  created() {
    this.logoUrl = wcconfig.assets.abacus;
  }
};
</script>
